module.exports = {"maturity":"Vencimento","amount":"Valor total","partialAmount":"Valor parcial","currency":"R$","open":"Em Aberto"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/InvoiceValue/data.json
// module id = 2084
// module chunks = 0